import { render } from "./thankPage.vue?vue&type=template&id=b6bca352&scoped=true"
import script from "./thankPage.vue?vue&type=script&lang=js"
export * from "./thankPage.vue?vue&type=script&lang=js"

import "./thankPage.vue?vue&type=style&index=0&id=b6bca352&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\jlm_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6bca352"]])

export default __exports__